<div class="grid-layout" *ngIf="submissionItems.length">
  <div>
    <span class="label-text">Submitted by</span>
  </div>

  <div class="submitters" *ngFor="let submissionItem of submissionItems">
    <ng-container *ngIf="submissionItem.id">
      <span class="label-text">Step {{ submissionItem.stepName }}</span>
      <span class="submitter-name">
        {{ submissionItem.user_name }}
      </span>
    </ng-container>
  </div>
</div>
